<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="page-order-view" class="data-list-container">
		<div>
			<div slot="header" class="w-full mb-12 flex" style="align-items: center;">
				<div class="flex flex-grow justify-start flex-wrap" :key="upStatus">
					<div class="flex justify-between items-center cursor-pointer"  @click="gotoSellList()">
						<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M20.5833 13H5.41666" stroke="#030960" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M13 20.5834L5.41666 13L13 5.41669" stroke="#030960" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
						<label class="dt-comeback ml-2">Trở lại</label>
					</div>
				</div>
			</div>
			<div v-if="sell">
				<div class="flex flex-grow justify-around flex-wrap">
					<div class="grow max-w-md mb-5">
						<div class="image-box">
							<img :src="activePhoto ? activePhoto.path : 'https://spp.agriindex.vn/storage/app/media/assets/images/noimg.jpg'"/>
						</div>
						<div class="flex justify-start flex-wrap mt-3">
							<img class="cursor-pointer mr-3 object-cover" width="100" height="100" :src="photo.path" :key="idxStatus" v-for="(photo, idxStatus) in sell.photos" @click="changePhoto(photo)"/>
						</div>
					</div>
					<div class="grow mb-5">
						<div class="mx-5 max-w-md">
							<label class="lb-tsp">{{sell.product.name || ''}}</label>
							<div class="flex flex-grow justify-between mt-8 lb-ttsp">
								<label>Giá (VND/KG)</label>
								<label class="ml-12">{{$helper.numFormat(sell.price)}}</label>
							</div>
							<div class="flex flex-grow justify-between mt-3 lb-ttsp">
								<label>Khối lượng (KG)</label>
								<label class="ml-12">{{$helper.numFormat(sell.quantity)}}</label>
							</div>
							<div class="grid mt-12">
								<label class="lb-tc">Tổng cộng</label>
								<label class="lb-tcgt my-3">{{ $helper.numFormat(sell.quantity * sell.price) }} VND</label>
								<label class="lb-vat">Đã bao gồm VAT</label>
								<vs-button title="Đặt lệnh ngay" class="w-22 font-bold py-0 px-3 rounded-none mt-6" :color="'primary'" :type="'filled'" @click="buyNow(sell)">MUA NGAY</vs-button>
							</div>
						</div>
					</div>
					<div class="grow mb-5" v-if="sell.supplier">
						<div class="grid mx-5 max-w-md">
							<label class="lb-ncc">Nhà cung cấp</label>
							<label class="lb-tcy mt-8">{{sell.supplier.name}}</label>
							<div class="flex flex-grow justify-start items-center mt-3">
								<label class="lb-dg2 mr-2">{{sell.supplier.vote_num ? (sell.supplier.total_rating / sell.supplier.vote_num).toFixed(1) : 0}}</label>
								<svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M16.7363 5.89649L11.7773 5.17579L9.56055 0.681648C9.5 0.558601 9.4004 0.458992 9.27735 0.398445C8.96876 0.246101 8.59375 0.373054 8.43946 0.681648L6.22266 5.17579L1.26368 5.89649C1.12696 5.91602 1.00196 5.98048 0.906256 6.07813C0.790556 6.19705 0.7268 6.35704 0.728998 6.52294C0.731195 6.68884 0.799166 6.84709 0.917975 6.9629L4.50587 10.4609L3.65821 15.4004C3.63833 15.5153 3.65105 15.6335 3.69491 15.7415C3.73878 15.8496 3.81204 15.9432 3.90639 16.0117C4.00074 16.0802 4.1124 16.1209 4.22872 16.1292C4.34503 16.1375 4.46134 16.113 4.56446 16.0586L9 13.7266L13.4356 16.0586C13.5566 16.1231 13.6973 16.1445 13.832 16.1211C14.1719 16.0625 14.4004 15.7402 14.3418 15.4004L13.4941 10.4609L17.082 6.9629C17.1797 6.8672 17.2441 6.74219 17.2637 6.60548C17.3164 6.26368 17.0781 5.94727 16.7363 5.89649Z" fill="#FCCE57"/>
								</svg>
								<label class="ml-5 lb-dg">{{sell.supplier.vote_num}} đánh giá</label>
							</div>
							<!--<div class="flex flex-grow justify-start items-center mt-8">
								<svg class="lb-sdt" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M22 16.92V19.92C22.0011 20.1985 21.9441 20.4741 21.8325 20.7293C21.7209 20.9845 21.5573 21.2136 21.3521 21.4018C21.1468 21.5901 20.9046 21.7335 20.6407 21.8227C20.3769 21.9119 20.0974 21.945 19.82 21.92C16.7428 21.5856 13.787 20.5341 11.19 18.85C8.77382 17.3146 6.72533 15.2661 5.18999 12.85C3.49997 10.2412 2.44824 7.27097 2.11999 4.17997C2.095 3.90344 2.12787 3.62474 2.21649 3.3616C2.30512 3.09846 2.44756 2.85666 2.63476 2.6516C2.82196 2.44653 3.0498 2.28268 3.30379 2.1705C3.55777 2.05831 3.83233 2.00024 4.10999 1.99997H7.10999C7.5953 1.9952 8.06579 2.16705 8.43376 2.48351C8.80173 2.79996 9.04207 3.23942 9.10999 3.71997C9.23662 4.68004 9.47144 5.6227 9.80999 6.52997C9.94454 6.8879 9.97366 7.27689 9.8939 7.65086C9.81415 8.02482 9.62886 8.36809 9.35999 8.63998L8.08999 9.90997C9.51355 12.4135 11.5864 14.4864 14.09 15.91L15.36 14.64C15.6319 14.3711 15.9751 14.1858 16.3491 14.1061C16.7231 14.0263 17.1121 14.0554 17.47 14.19C18.3773 14.5285 19.3199 14.7634 20.28 14.89C20.7658 14.9585 21.2094 15.2032 21.5265 15.5775C21.8437 15.9518 22.0122 16.4296 22 16.92Z" stroke="black" stroke-opacity="0.7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
								<label class="lb-sdt ml-5">{{sell.supplier.phone}}</label>
							</div>-->
							<div class="flex flex-grow justify-start items-center mt-12"></div>
							<div class="flex flex-wrap justify-start items-center mt-5">
								<label class="lb-sdt">
								<svg class="lb-sdt mr-5" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z" stroke="black" stroke-opacity="0.7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="black" stroke-opacity="0.7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>{{sell.supplier.address}}</label>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<OrderForm :isPopupActive="customerDialog" @closePopup="toggleCustomerDialog" :data="customerData" />
	</div>
</template>

<script>
import CbsPagination from "@/components/cbs-pagination/CbsPagination";
import UserDetail from "./UserDetail.vue";
import OrderForm from "./OrderForm.vue";
import OrderDetail from "./OrderDetail.vue";
import KcsForm from "./KcsForm.vue";
import ChooseSells from "./ChooseSells.vue";
import SellerRatingForm from "./SellerRatingForm.vue";

export default {
	components: {
		CbsPagination,
		UserDetail,
		OrderForm,
		OrderDetail,
		KcsForm,
		ChooseSells,
		SellerRatingForm
	},
	data() {
		return {
			sell: null,
			activePhoto: null,
			customerDialog: false,
			customerData: {},
		};
	},
	computed: {
		total() {
			return Math.ceil(this.$store.state.moduleProduct.sellTotal / this.customLimit);
		},
	},
	methods: {
		toggleCustomerDialog(val = false) {
			this.customerDialog = val;
			if (!val) {
				this.customerData = {};
				this.getGetUsers();
			}
		},
		buyNow(sell) {
			sell.type = 1;
			sell.orderNow = 1;
			sell.address = null;
			this.customerData = sell;
			this.customerDialog = true;
		},
		gotoSellList() {
			this.$router.push('/cac-lenh-ban');
		},
		changePhoto(photo) {
			this.activePhoto = photo;
		},
		async getOrder() {
			console.log('getOrder');
			this.$vs.loading();
			try {
				let {id} = this.$route.params
				await this.$store.dispatch("moduleProduct/getOrderById", id).then(response => {
					this.sell = response;
					if (response && response.photos) {
						this.activePhoto = response.photos[0];
					}
				});
				this.$vs.loading.close();
			} catch (error) {
				this.$vs.loading.close();
			}
		},
	},
	watch: {
	},
	created() {
		this.getOrder();
	},
};
</script>

<style lang="scss">
.vx-navbar-wrapper {
	height: 80px !important;
}
.custom-dialog {
	z-index: 10001 !important;
}
.lb-vat {
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
	line-height: 15px;
	/* identical to box height */


	color: #000000;
}
.lb-tcgt {
	font-style: normal;
	font-weight: 700;
	font-size: 32px;
	line-height: 40px;
	/* identical to box height */


	color: #000000;
}
.lb-tc {
	font-style: normal;
	font-weight: 400;
	font-size: 20px;
	line-height: 25px;
	/* identical to box height */


	color: #000000;
}
.lb-ttsp label {
	font-style: normal;
	font-weight: 400;
	font-size: 20px;
	line-height: 25px;
	/* identical to box height */


	color: #000000;
}
.lb-tsp {
	font-style: normal;
	font-weight: 700;
	font-size: 32px;
	line-height: 40px;
	/* identical to box height */


	color: #057FBB;
}
.lb-sdt {
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 20px;
	/* identical to box height */


	color: rgba(0, 0, 0, 0.7);
}
.lb-dg {
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 20px;
	/* identical to box height */


	color: #057FBB;
}
.lb-dg2 {
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 20px;
	/* identical to box height */


	color: rgba(0, 0, 0, 0.5);
}
.lb-tcy {
	font-style: normal;
	font-weight: 500;
	font-size: 24px;
	line-height: 30px;
	/* identical to box height */


	color: #000000;

}
.lb-ncc {
	font-style: normal;
	font-weight: 500;
	font-size: 20px;
	line-height: 25px;
	/* identical to box height */


	color: #057FBB;
}
.image-box img {
	object-fit: cover;
	width: 100%;
	// height: 100%;
}
.dt-comeback {
	font-style: normal;
	font-weight: 700;
	font-size: 14px;
	line-height: 18px;
	/* identical to box height */


	color: #030960;
	cursor: pointer;
}

@media screen and (min-width: 1201px) and (max-width: 1211px), only screen and (min-width: 636px) and (max-width: 991px) {
	#account-info-col-1 {
		width: calc(100% - 12rem) !important;
	}

	// #account-manage-buttons {
	//   width: 12rem !important;
	//   flex-direction: column;

	//   > button {
	//     margin-right: 0 !important;
	//     margin-bottom: 1rem;
	//   }
	// }
}
</style>
